<template>
  <v-layout>
    <v-flex xs6 offset-xs3>
      <v-card class='ma-5'>
        <v-card-title primary-title>
          <v-flex xs9>
            <h3 class="headline mb-0">Edit Group: {{group.name}}</h3>
            <v-text-field label="Name" v-model="group.name" required></v-text-field>
            <v-text-field label="Purpose" v-model="group.description"></v-text-field>
            <v-select label="Group Type" v-model="group.group_type_id" :items="group_types" item-text="friendly_name" item-value="id" required :loading='this.group_types.length>0?false:"primary"'></v-select>
            <v-checkbox label="Public" v-model="group.public"></v-checkbox>

                    <v-select
                      label="Add Members"
                      :items="ac_results"
                      content-class="dropwdown_users_list"
                      v-model="members"
                      item-text="display_name"
                      item-value="id"
                      item-avatar="profile_photo.avatar"
                      :loading="loading"
                      multiple
                      chips
                      cache-items
                      :search-input.sync="search"
                      autocomplete
                    >

                      <template slot="selection" slot-scope="data">
                        <v-chip
                          close
                          @input="data.parent.selectItem(data.item)"
                          :selected="data.selected"
                          class="chip--select-multi"
                          :key="JSON.stringify(data.item)"
                        >
                          <template v-if="typeof data.item.profile_photo.avatar !== 'undefined'">
                            <v-avatar>
                              <img :src="data.item.profile_photo.avatar">
                            </v-avatar>
                          </template>
                          <template v-else>
                             <v-avatar class="accent">
                               {{ data.item.first_name.slice(0, 1).toUpperCase() }}
                               {{ data.item.last_name.slice(0, 1).toUpperCase() }}
                              </v-avatar>
                          </template>
                          {{ data.item.display_name }}
                        </v-chip>
                      </template>
                      <template slot="item" slot-scope="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-tile-content v-text="data.item"></v-list-tile-content>
                        </template>
                        <template v-else>
                          <template v-if="typeof data.item.profile_photo.avatar !== 'undefined'">
                            <v-list-tile-avatar>
                              <img :src="data.item.profile_photo.avatar">
                            </v-list-tile-avatar>
                          </template>
                          <template v-else>
                             <v-list-tile-avatar class="accent">
                               {{ data.item.first_name.slice(0, 1).toUpperCase() }}
                               {{ data.item.last_name.slice(0, 1).toUpperCase() }}
                              </v-list-tile-avatar>
                          </template>
                          <v-list-tile-content>
                            <v-list-tile-title v-html="data.item.display_name"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="data.item.email"></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-select>

          </v-flex>
        </v-card-title>
        <v-card-actions>
          <v-btn flat color="orange" @click.enter="saveGroup">Save Changes</v-btn>
          <v-btn flat outline to='/groups'>Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  computed: {
    group_id() {
      return this.$route.params.id;
    }
  },
  data() {
    return {
      loading: false,
      search: null,
      ac_results: [],
      group: {},
      group_types: {},
      members: []
    };
  },
  watch: {
    search(val) {
      val && this.querySelections(val);
    }
  },
  methods: {
    querySelections(v) {
      this.loading = true;
      setTimeout(() => {
        this.$http.get("users/autocomplete?q=" + v).then(
          response => {
            this.ac_results = response.body;
            console.log(this.ac_results);
          },
          response => {
            console.log("Error getting users from autocomplete.");
          }
        );
        this.loading = false;
      }, 300);
    },
    saveGroup() {
      console.log("Save Group Triggered!");
      var formData = {
        name: this.group.name,
        description: this.group.description,
        group_type_id: this.group.group_type_id,
        public: this.group.public,
        users: this.members
      };
      this.$http.put("groups/" + this.$route.params.id, formData).then(
        response => {
          this.$store.commit("updateMessage", {
            message: "Group saved.",
            snackbar: true
          });
        },
        response => {
          console.log("Error saving profile");
        }
      );
    }
  },
  mounted() {
    this.$http.get("groups/" + this.$route.params.id).then(
      response => {
        this.group = response.body.data;
      },
      response => {
        console.log("Error getting group types.");
      }
    );
    this.$http.get("groups/members/" + this.$route.params.id).then(
      response => {
        this.members = response.body.data;
        this.ac_results = response.body.data;
      },
      response => {
        console.log("Error getting group types.");
      }
    );
    this.$http.get("group_types/list").then(
      response => {
        this.group_types = response.body.data;
      },
      response => {
        console.log("Error getting group types.");
      }
    );
  }
};
</script>
